import React from "react";

export function MonitorDetectionOverlay({ isInitialBlock = false }) {
  return (
    <div className="fixed inset-0 z-[99999] flex flex-col items-center justify-center bg-black bg-opacity-99 text-center px-10 space-y-6">
      <h1 className="text-white text-4xl md:text-5xl font-bold leading-tight">
        External Monitor Detected
      </h1>

      {isInitialBlock ? (
        <>
          <p className="text-white text-2xl md:text-3xl leading-snug">
            Please disconnect all external displays
            <br />
            before starting your assessment.
          </p>

          <p className="text-white text-lg opacity-80 mt-4">
            Your interview cannot begin until you return to a single screen.
          </p>
        </>
      ) : (
        <>
          <p className="text-white text-2xl md:text-3xl leading-snug">
            Please disconnect all external displays
            <br />
            to continue with your assessment.
          </p>

          <p className="text-white text-lg opacity-80 mt-4">
            Your interview is paused until you return to a single screen.
          </p>
        </>
      )}
    </div>
  );
}

export default MonitorDetectionOverlay;
